import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { map } from 'lodash'

import ImagesSlider from './ImagesSlider'
import CloseGallery from '../../assets/icons/close-gallery.svg'

import '../../styles/scss/elements/gallery-modal.scss'

const GalleryModal = ({ photos, isModalOpen, closeModal }) => {
  const [isCarouselOpen, setIsCarouselOpen] = useState(false)
  const [slideIndex, setSlideIndex] = useState(0)

  return (
    <div>
      <ReactModal
        ariaHideApp={false}
        className="ylg-ms__accommodation-details__gallery-modal"
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        overlayClassName="ylg-ms__accommodation-details__gallery-modal-overlay"
        parentSelector={() =>
          document.getElementById('ylg-ms__accommodation-details')
        }
      >
        <div className="photos-modal-container">
          <button onClick={closeModal} className="btn btn-close-gallery">
            <img
              src={CloseGallery}
              alt="Close"
              className="icon-close-gallery"
            />
          </button>
          <div className="modal-photos">
            {map(photos, (photo, index) => (
              // eslint-disable-next-line jsx-a11y/img-redundant-alt
              <img
                className="modal-photo"
                key={index}
                src={photo?.url}
                alt={photo?.caption}
                onClick={() => {
                  setIsCarouselOpen(true)
                  setSlideIndex(index)
                }}
              />
            ))}
          </div>
        </div>
      </ReactModal>
      <ImagesSlider
        photos={photos}
        isCarouselOpen={isCarouselOpen}
        closeCarouselModal={() => setIsCarouselOpen(false)}
        slideIndex={slideIndex}
      />
    </div>
  )
}

export default GalleryModal
